import React, { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import { resolveImageSrc } from '../utils/imageUtils';

export default function SafeImage({
  source,
  src,
  resolver = resolveImageSrc,
  alt = '',
  className = '',
  fallbackClassName = '',
  fallbackIcon: FallbackIcon = ImageOff,
  fallbackLabel = '',
  loading = 'lazy',
  onError,
  ...props
}) {
  const resolvedSrc = resolver(source ?? src);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [resolvedSrc]);

  if (!resolvedSrc || failed) {
    return (
      <div
        className={`${fallbackClassName || className} rounded border border-dashed border-zinc-700 bg-zinc-950/70 flex flex-col items-center justify-center gap-1 text-zinc-600`}
        aria-label={alt || fallbackLabel || 'Image unavailable'}
      >
        <FallbackIcon className="w-5 h-5" />
        {fallbackLabel && (
          <span className="text-[10px] uppercase tracking-widest text-center leading-tight">{fallbackLabel}</span>
        )}
      </div>
    );
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      loading={loading}
      onError={(event) => {
        setFailed(true);
        if (onError) onError(event);
      }}
      {...props}
    />
  );
}
